import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { firstValueFrom } from 'rxjs';

import { getSellerProviders } from '../../freight/freight-api';
import { refreshSellerFreightProvidersSuccess } from '../../store/seller/seller.actions';

// Some registration success callbacks (CUI's onRegisterSuccess) don't hand back the new
// provider id directly. Fetches the fresh provider list, hydrates Redux with the result, and
// resolves the connected id (or null if the fetch itself fails) so callers never have to wait
// for a separate refresh to land later.
export const useResolveConnectedProviderId = () => {
  const dispatch = useDispatch();

  return useCallback(async (): Promise<number | null> => {
    try {
      const sellerFreightProviders = await firstValueFrom(getSellerProviders());
      dispatch(refreshSellerFreightProvidersSuccess(sellerFreightProviders));
      return sellerFreightProviders[0]?.sellerFreightProviderId ?? null;
    } catch {
      return null;
    }
  }, [dispatch]);
};
